import { IModalDescription, IModalProps, ViewVariant } from '@cp/shared/modal';
import { CatalogItemResponseProps } from '../model';

export const PRICE_VACANCY_MODAL: IModalDescription<CatalogItemResponseProps> = {
  nss: 'PRICE_VACANCY_MODAL',
  loader: () => import('../ui/responseModal').then((module) => module.CatalogItemResponseModal),
  layout: {
    desktop: ViewVariant.Dialog,
    mobile: ViewVariant.DrawerBottom,
  },
};

export const VACANCY_SUCCESS_MODAL: IModalDescription<IModalProps> = {
  nss: 'VACANCY_SUCCESS_MODAL',
  loader: () => import('../ui/responseSuccessModal').then((module) => module.SuccessModal),
  layout: {
    desktop: ViewVariant.Dialog,
    mobile: ViewVariant.DrawerBottom,
  },
};
